import { IEdgeServers } from '../../../../core/api/dto/BuffetDishDto'
import { setEdgeServers } from '../../../../shared/lib/setEdgeServers'
import {
  useDeleteTagsToFotoboxesMutation,
  useSendTagsToFotoboxesMutation,
} from '../../../../core/api/TagsApi'

export const useUpdateTagsStations = (
  oldValue: IEdgeServers[],
  newValue: IEdgeServers[],
) => {
  const { deletedItems, addedItems } = setEdgeServers(oldValue, newValue) || {}

  const [sendTagsToFotoboxes] = useSendTagsToFotoboxesMutation()
  const [deleteTagsToFotoboxes] = useDeleteTagsToFotoboxesMutation()

  const onUpdateStation = (tagsGuids: string) => {
    if (
      deletedItems?.length &&
      process.env.REACT_APP_TYPE_SERVER === 'MainServer'
    ) {
      deleteTagsToFotoboxes({
        tagsGuids: [tagsGuids],
        edgeServersGuids: deletedItems,
      })
    }
    if (
      addedItems?.length &&
      process.env.REACT_APP_TYPE_SERVER === 'MainServer'
    ) {
      sendTagsToFotoboxes({
        tagsGuids: [tagsGuids],
        edgeServersGuids: addedItems,
      })
    }
  }
  return { onUpdateStation }
}
